<script>
import UserCDDs from './User.CDDs'
export default {
  name: 'user-bdds',
  extends: UserCDDs,
}
</script>
